import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';

import { alphabeticallySort,textContains } from '../../../shared/utils';

class RetailerList extends Component {
  constructor(){
    super();

    this.state = {
      expandedId:null,
      isLoading:false
    }
  }

  componentDidMount(){
    this.setState({isLoading:true});

    Promise.all([
      this.props.loadBrands(),
      this.props.loadRetailers(),
      this.props.loadAgencies()
    ])
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  handleExpand(event,retailerId){
    event.preventDefault();

    this.setState({expandedId:retailerId})
  }

  render(){
    const { retailers } = this.props;

    const { expandedId } = this.state;

    return (
      <Container>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>Publishers</h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref='/superadmin/configuration/retailers/new'
            >
              Add Publisher
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={retailers}
              searchPromptText='Search by name'
              emptyText='Loading publishers...'
              columns={[{
                name:'logo',
                width:15,
                renderCell:(item) => (item.logoURL ? (
                  <img
                    style={{ height:50 }}
                    src={item.logoURL}
                    alt={`Logo for publisher ${item.name}`}
                  />
                ) : (
                  <span>N/A</span>
                ))
              },{
                display:'Publisher',
                name:'name',
                width:20,
                sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                renderCell:(item) => (<Link to={`/superadmin/configuration/retailers/${item.id}/edit`}>{item.name}</Link>)
              },
              {
                display:'Brands',
                width:45,
                renderCell:(item) => item.id === expandedId ? (
                  <div>
                    {item.approvedBrands.map((b,i) => {
                      return (
                        <span key={b.id}>
                          <Link to={`/superadmin/brands/${b.id}/edit`}>
                            {b.name}
                          </Link>
                          {i !== item.approvedBrands.length - 1  && (
                            <span>,&nbsp;</span>
                          )}
                        </span>
                      )
                    })}
                  </div>
                ) : (
                  <div>
                    {item.approvedBrands.slice(0,3).map((b) => (
                      <span key={b.id}>
                        <Link to={`/superadmin/brands/${b.id}/edit`}>
                          {b.name}
                        </Link>
                        ,&nbsp;
                      </span>
                    ))}
                    {item.approvedBrands.length > 3 && (
                      <a
                        href='/'
                        onClick={(event) => this.handleExpand(event,item.id)}
                      >
                        and {item.approvedBrands.length - 3} others...
                      </a>
                    )}
                  </div>
                )
              },{
                width:20,
                renderCell:(item) => (
                  <div className='pull-right'>
                    <Button
                      size='sm'
                      linkHref={`/superadmin/configuration/retailers/${item.id}/edit`}
                      textColor='#666666'
                      borderColor='#cccccc'
                      backgroundColor='#fff'
                    >
                      Edit
                    </Button>
                  </div>
                )
              }]}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default RetailerList;



// WEBPACK FOOTER //
// ./src/routes/RetailerList/components/RetailerList.js